<div *ngIf="emergencyDetail$ | async as emergency">
    <form [formGroup]="form">
        <div    class="flex-gap-12vw flex-space-between-center flex-row">
            <label class="mt-4">Sub&nbsp;Type</label>
            <mat-form-field class="flex-40" >
                <input matInput
                       formControlName="subType"
                       type="text"
                       placeholder="Sub Type"
                >
            </mat-form-field>
        </div>

        <div   
             *ngIf="form['controls']['subType'].value === 'MESSAGING'" class="flex-gap-10vw flex-space-between-center flex-row">
            <label class="mt-4">Status Message</label>
            <mat-form-field class="flex-40" >
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          formControlName="statusMessage"
                          type="text"
                          placeholder="Status Message"
                ></textarea>
            </mat-form-field>
        </div>

        <div    class="flex-gap-13vw flex-space-between-center flex-row">
            <label class="mt-4">Active</label>
            <mat-form-field class="flex-40" >
                <mat-select
                    formControlName="active"
                    type="select"
                    placeholder="True or False?"
                >
                    <mat-option [value]="true">
                        True
                    </mat-option>
                    <mat-option [value]="false">
                        False
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</div>
